// DS: MO 0.11
import React from 'react';
import c from 'classnames';
import { useSelectByTheme } from '@wix/da-react-context/pkg/ThemeContext';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import SolidButton from '../Buttons/SolidButton';
import ClockIcon from '../Icons/24x24/Clock';
import Countdown from '../Time/Countdown';
import s from './DealerCard.scss';
const DealerCard = ({ className, title, description, cta, titleColor, bodyColor, backgroundColor, fontSize = 'small', align = 'left', valign = 'top', headerImage, backgroundImageDark, backgroundImageLight, backgroundImageGreen, countdownTimer })=>{
    let ctaLabel = '', ctaUrl = '', ctaColor = '', ctaBackgroundColor = '';
    if (cta) {
        ctaLabel = cta.label || '';
        ctaUrl = cta.url || '';
        ctaColor = cta.color || '';
        ctaBackgroundColor = cta.backgroundColor || '';
    }
    const backgroundImage = useSelectByTheme({
        dark: backgroundImageDark || '',
        light: backgroundImageLight || '',
        green: backgroundImageGreen || ''
    });
    let content = null;
    // Background-only
    if (!(title && description) && backgroundImage) {
        content = /*#__PURE__*/ React.createElement(BiLink, {
            href: ctaUrl
        }, /*#__PURE__*/ React.createElement("img", {
            src: backgroundImage,
            alt: "Ad slot",
            className: s['bg-img']
        }));
    }
    // Small text with optional header
    if (title || description) {
        const innerContent = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", null, title && /*#__PURE__*/ React.createElement(Heading, {
            className: s['heading'],
            style: {
                color: titleColor
            }
        }, title), description && /*#__PURE__*/ React.createElement("p", {
            className: s['text'],
            style: {
                color: bodyColor
            }
        }, description)), /*#__PURE__*/ React.createElement("div", null, ctaUrl && /*#__PURE__*/ React.createElement(SolidButton, {
            className: s['cta'],
            size: "medium",
            variant: "approval-green",
            href: ctaUrl,
            target: "_blank",
            rel: "noopener",
            style: {
                color: ctaColor,
                backgroundColor: ctaBackgroundColor
            }
        }, ctaLabel || 'Default CTA'), countdownTimer && /*#__PURE__*/ React.createElement("div", {
            className: s['countdown'],
            style: {
                color: bodyColor
            }
        }, /*#__PURE__*/ React.createElement(ClockIcon, {
            className: s['countdown-icon'],
            disableDefaultColors: true
        }), /*#__PURE__*/ React.createElement(Countdown, {
            countToDate: `${countdownTimer}`,
            minutesOnly: true,
            renderTimer: (d, h, m)=>`${d}d ${h}h ${m}m`
        }))));
        if (fontSize === 'small') {
            content = /*#__PURE__*/ React.createElement("div", {
                className: c(s['font-small'], s[`align-${align}`])
            }, /*#__PURE__*/ React.createElement("div", {
                className: s['small-bg'],
                style: {
                    backgroundImage: headerImage ? `url(${headerImage})` : undefined
                }
            }), /*#__PURE__*/ React.createElement("div", {
                className: c(s['small-content'], backgroundColor && s['small-custom']),
                style: {
                    backgroundColor
                }
            }, innerContent));
        }
        if (fontSize === 'large') {
            content = /*#__PURE__*/ React.createElement("div", {
                className: c(s['font-large'], s[`align-${align}`])
            }, /*#__PURE__*/ React.createElement("div", {
                className: c(s['large-content'], s[`valign-${valign}`]),
                style: {
                    backgroundColor,
                    backgroundImage: backgroundImage && `url(${backgroundImage})`
                }
            }, /*#__PURE__*/ React.createElement("div", {
                className: s['large-overlay']
            }, innerContent)));
        }
    }
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, content);
};
DealerCard.displayName = 'DealerCard';
export default DealerCard;
